import { render, staticRenderFns } from "./ChatUserButton.vue?vue&type=template&id=05d2642e&"
import script from "./ChatUserButton.vue?vue&type=script&lang=js&"
export * from "./ChatUserButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports